import * as React from 'react';

import * as styles from './RosreestrCheckedTooltipContent.css';

interface IRosreestrCheckedTooltipContentProps {
  tooltipText: string;
}

export const RosreestrCheckedTooltipContent = ({ tooltipText }: IRosreestrCheckedTooltipContentProps) => {
  return (
    <ul className={styles['list']}>
      {tooltipText
        .split('\n')
        .filter(line => line.trim() !== '')
        .map((text, index) => (
          <li key={index}>{text}</li>
        ))}
    </ul>
  );
};
